<div class="row mt-1" style="padding-top: 5%">
    <div class="col-lg-3 col-md-3 col-sm-3">
      <img
        src="{{product.images[0]}}"
        alt=""
        style="width: 100px; height: 100px; object-fit: cover;"
      />
    </div>
    <div class="col-lg-1 col-md-1 col-sm-1"></div>
    <div class="col-lg-8 col-md-8 col-sm-8">
      <div class="row">
        <h5 style="font-weight: bolder" class="col-lg-7 col-sm-12">
          {{product.name}}
        </h5>
        <div class="col-lg-1"></div>
        <h5 class="col-lg-2 col-sm-12">Rs.{{price}}</h5>
      </div>
      <h6>Size: {{data.size || 'None'}}</h6>
      <!-- <br>
           <h5>Qty:1</h5> -->
    </div>
  </div>